import { useDispatch } from "react-redux";
import { checkLoggedin } from "../reducers/authUserSlice";
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { handleExpiredSession } from "../components/auth/HandleExpiredSession";

const INTERVAL_MS = 15 * 60 * 1000; // 15 minutes
const STATUS_FULFILLED = "fulfilled";
const MESSAGE_INVALID = "Session expired";

export default function SessionWatcher() {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const checkSession = () => {
    return dispatch(checkLoggedin())
      .then(
        (response) =>
          response &&
          response.meta &&
          response.meta.requestStatus === STATUS_FULFILLED,
      )
      .catch(() => false)
      .then((isValid) => {
        if (!isValid) {
          console.log(MESSAGE_INVALID);
          handleExpiredSession(dispatch, navigate);
        }
      });
  };

  useEffect(() => {
    checkSession();

    const interval = setInterval(() => {
      checkSession();
    }, INTERVAL_MS);

    // Clean up the interval on component unmount
    return () => clearInterval(interval);
  }, [dispatch, navigate]);

  return null; // This component doesn't render anything
}
